(() => {
  document.body.classList.add('pp-v22-page');

  const money = (cents) => '$' + (Number(cents || 0) / 100).toFixed(2);

  document.querySelectorAll('[data-pp-v22]').forEach((root) => {
    const kind = root.dataset.kind;
    const addButton = root.querySelector('[data-pp-v22-add]');
    const errorBox = root.querySelector('[data-pp-v22-error]');
    const pairBuilder = kind === 'allergy'
      ? root.querySelector('[data-pp-multi-buy]')?.closest('.pp-cro-builder')
      : null;
    const snuffleSummary = root.querySelector('[data-pp-v22-snuffle-summary]');
    const snuffleVisuals = Array.from(root.querySelectorAll('[data-pp-snuffle-visual]'));
    const packages = Array.from(root.querySelectorAll('[data-package]'));
    const supplementPicker = root.querySelector('[data-pp-supplement-picker]');
    const supplementChoices = Array.from(root.querySelectorAll('[data-supplement-choice]'));
    const purchaseWrap = root.querySelector('[data-pp-purchase-choice-wrap]');
    const purchaseChoices = Array.from(root.querySelectorAll('[data-pp-purchase-choice]'));
    const frequencyWrap = root.querySelector('[data-pp-frequency-wrap]');
    const planSelect = root.querySelector('[data-pp-plan-select]');
    const purchaseSummary = root.querySelector('[data-pp-purchase-summary]');
    const baseVariant = Number(root.dataset.variant);
    const matVariant = Number(root.dataset.matVariant);
    const matTreatVariant = Number(root.dataset.matTreatVariant || root.dataset.matVariant);
    let basePrice = Number(root.dataset.basePrice);
    let matPrice = Number(root.dataset.matPrice || basePrice);
    const offerPrice = Number(root.dataset.offerPrice || 4999);
    const matJarPrice = Number(root.dataset.matJarPrice || 5999);
    const addonCheck = root.querySelector('[data-pp-mat-addon-check]');
    const addonSelect = root.querySelector('[data-pp-mat-addon-select]');
    const addonSelected = () => kind === 'snuffle' && ['single', 'double'].includes(selected) && addonCheck?.checked === true;
    function syncAddon() {
      const wrap = root.querySelector('[data-pp-mat-addon]');
      if (!wrap) return;
      wrap.hidden = !['single', 'double'].includes(selected);
      if (!['single', 'double'].includes(selected)) addonCheck.checked = false;
      wrap.querySelectorAll('[data-pp-mat-addon-image]').forEach(image => { image.hidden = image.dataset.ppMatAddonImage !== addonSelect.value; });
      wrap.querySelector('[data-pp-mat-addon-benefit]').textContent = addonSelect.selectedOptions[0]?.dataset.addonBenefit || '';
    }
    let selected = packages.find((card) => card.getAttribute('aria-pressed') === 'true')?.dataset.package || (kind === 'allergy' ? 'duo' : 'single');
    let purchaseType = 'one-time';
    let planMap = {};

    try {
      planMap = JSON.parse(root.querySelector('[data-pp-plan-map]')?.textContent || '{}');
    } catch (error) {
      console.error('PuzzlePup subscription plans could not be read.', error);
    }

    function selectedSupplement() {
      const checked = supplementChoices.find((choice) => choice.checked);
      return {
        id: Number(checked?.value || root.dataset.allergyVariant),
        name: checked?.dataset.supplementName || 'Allergy Soft Chews'
      };
    }

    function planVariant() {
      return kind === 'allergy' ? baseVariant : selectedSupplement().id;
    }

    function availablePlans() {
      return planMap[String(planVariant())] || [];
    }

    function syncPlans() {
      if (!planSelect) return;
      const previousName = planSelect.selectedOptions?.[0]?.dataset.planName;
      const plans = availablePlans();
      planSelect.replaceChildren(...plans.map((plan) => {
        const option = document.createElement('option');
        option.value = plan.id;
        option.dataset.priceCents = plan.price;
        option.dataset.planName = plan.name;
        option.textContent = plan.name + ' · save 15%';
        return option;
      }));
      const matching = Array.from(planSelect.options).find((option) => option.dataset.planName === previousName);
      if (matching) matching.selected = true;
    }

    function selectedPlan() {
      const option = planSelect?.selectedOptions?.[0];
      return option ? {
        id: Number(option.value),
        name: option.dataset.planName || option.textContent,
        price: Number(option.dataset.priceCents || 0)
      } : null;
    }

    function hasSubscriptionJar() {
      return kind === 'allergy' || (kind === 'snuffle' && selected === 'bundle');
    }

    function selectedTotal() {
      if (purchaseType === 'subscription' && hasSubscriptionJar()) {
        const planPrice = selectedPlan()?.price || basePrice;
        if (kind === 'allergy') {
          if (selected === 'duo') return planPrice * 2;
          if (selected === 'mat-bundle') return planPrice + matPrice;
          return planPrice;
        }
        return matPrice + planPrice;
      }
      if (kind === 'snuffle' && selected === 'double') return 5999 + (addonSelected() ? 1749 : 0);
      if ((kind === 'allergy' && selected === 'mat-bundle') || (kind === 'snuffle' && selected === 'bundle')) return matJarPrice;
      return selected === 'single' ? basePrice + (addonSelected() ? 1749 : 0) : offerPrice;
    }

    function selectedLabel() {
      const subscribing = purchaseType === 'subscription' && hasSubscriptionJar();
      if (kind === 'allergy') {
        if (selected === 'single') return subscribing ? 'Subscribe to 1 Allergy jar' : 'Add 1 Allergy jar';
        if (selected === 'mat-bundle') return subscribing ? 'Add Mat + subscribe to Allergy' : 'Add Allergy jar + Snuffle Mat';
        return subscribing ? 'Subscribe to 2 Allergy jars' : 'Add 2 Allergy jars';
      }
      if (selected === 'single') return addonSelected() ? 'Add Mat, FREE treats + jar' : 'Add Mat + FREE treats';
      if (selected === 'double') return addonSelected() ? 'Add 2 Snuffle Mats + jar' : 'Add 2 Snuffle Mats';
      return (subscribing ? 'Add Mat + subscribe to ' : 'Add Mat + ') + selectedSupplement().name;
    }

    function render() {
      syncAddon();
      packages.forEach((card) => {
        const active = card.dataset.package === selected;
        card.classList.toggle('is-selected', active);
        card.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (supplementPicker) supplementPicker.hidden = selected !== 'bundle';
      if (purchaseWrap) purchaseWrap.hidden = !hasSubscriptionJar();
      syncPlans();
      const showFrequency = purchaseType === 'subscription' && hasSubscriptionJar() && availablePlans().length > 0;
      if (frequencyWrap) frequencyWrap.hidden = !showFrequency;
      if (purchaseSummary) {
        purchaseSummary.textContent = showFrequency
          ? selectedPlan().name + ': 15% off every delivery. Skip, pause, change, or cancel anytime.'
          : 'One-time purchase selected. Today’s bundle prices stay available.';
      }
      const usePairBuilder = Boolean(pairBuilder && selected === 'duo' && purchaseType === 'one-time');
      if (pairBuilder) {
        pairBuilder.hidden = !usePairBuilder;
        pairBuilder.style.display = usePairBuilder ? '' : 'none';
      }
      if (addButton) {
        addButton.hidden = usePairBuilder;
        addButton.style.display = usePairBuilder ? 'none' : '';
        addButton.textContent = selectedLabel() + ' · ' + money(selectedTotal());
      }
      if (kind === 'snuffle') {
        if (snuffleSummary) snuffleSummary.textContent = selected === 'double'
          ? addonSelected() ? 'Two full-size Mats and your selected jar · $77.48. One-time purchase. Treat bag is not included.' : 'Two full-size Snuffle Mats. One-time purchase. Save $19.99 automatically. Treat bag is not included.'
          : addonSelected() ? 'Your Mat, FREE treat bag and selected jar · $57.48. One-time purchase. Contains peanuts.' : 'One premium Mat and a FREE 25-count treat bag. One-time purchase. Contains peanuts.';
        snuffleVisuals.forEach((visual) => { visual.hidden = visual.dataset.ppSnuffleVisual !== selected; });
        const stickyPrice = root.querySelector('.ppv22__sticky > span');
        if (stickyPrice) stickyPrice.textContent = (selected === 'single' ? 'Mat + FREE treats' : selected === 'double' ? '2 Snuffle Mats' : 'Mat + supplement') + ' · ' + money(selectedTotal());
      }
    }

    if (kind === 'snuffle') {
      root.querySelectorAll('.smf-button').forEach((link) => link.addEventListener('click', () => {
        selected = 'single';
        purchaseType = 'one-time';
        render();
      }));
    }

    packages.forEach((card) => card.addEventListener('click', () => {
      selected = card.dataset.package;
      if (kind === 'snuffle' && selected !== 'bundle') {
        purchaseType = 'one-time';
        purchaseChoices.forEach((choice) => { choice.checked = choice.value === 'one-time'; });
      }
      render();
    }));
    supplementChoices.forEach((choice) => choice.addEventListener('change', render));
    purchaseChoices.forEach((choice) => choice.addEventListener('change', () => {
      purchaseType = choice.value;
      render();
    }));
    planSelect?.addEventListener('change', render);
    addonCheck?.addEventListener('change', render);
    addonSelect?.addEventListener('change', render);

    addButton?.addEventListener('click', async () => {
      const items = [];
      const subscription = purchaseType === 'subscription' && hasSubscriptionJar() ? selectedPlan() : null;
      const campaign = kind === 'allergy' ? 'Allergy funnel' : 'Snuffle funnel';
      const supplementProperties = {
        _PuzzlePup_campaign: campaign,
        _PuzzlePup_purchase: subscription ? 'Subscribe and save 15%' : 'One-time'
      };

      if (kind === 'allergy') {
        const supplementItem = {
          id: baseVariant,
          quantity: selected === 'duo' ? 2 : 1,
          properties: {
            ...supplementProperties,
            _PuzzlePup_offer: selected === 'duo' ? '2 jars' : selected === 'mat-bundle' ? 'Jar + Mat' : '1 jar'
          }
        };
        if (subscription) supplementItem.selling_plan = subscription.id;
        items.push(supplementItem);
        if (selected === 'mat-bundle') {
          items.push({ id: matVariant, quantity: 1, properties: { _PuzzlePup_campaign: campaign, _PuzzlePup_offer: 'Jar + Mat' } });
        }
      } else if (selected === 'single') {
        items.push({ id: matTreatVariant, quantity: 1, properties: { _PuzzlePup_campaign: campaign, _PuzzlePup_offer: 'Mat + FREE 25-count treat bag' } });
      } else if (selected === 'double') {
        items.push({ id: matVariant, quantity: 2, properties: { _PuzzlePup_campaign: campaign, _PuzzlePup_offer: '2 Mats $59.99' } });
      } else {
        const supplement = selectedSupplement();
        items.push({ id: matVariant, quantity: 1, properties: { _PuzzlePup_campaign: campaign, _PuzzlePup_offer: 'Mat + supplement' } });
        const supplementItem = {
          id: supplement.id,
          quantity: 1,
          properties: { ...supplementProperties, _PuzzlePup_offer: 'Mat + ' + supplement.name }
        };
        if (subscription) supplementItem.selling_plan = subscription.id;
        items.push(supplementItem);
      }

      if (addonSelected()) items.push({ id: Number(addonSelect.value), quantity: 1, properties: { _PuzzlePup_campaign: campaign, _PuzzlePup_offer: 'Mat jar add-on' } });

      const original = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = 'Adding your pup’s pick…';
      if (errorBox) errorBox.hidden = true;

      try {
        if (typeof window.PuzzlePupOfferEngine?.addAndVerify !== 'function') {
          throw new Error('Offer verification is still loading. Please try again.');
        }
        await window.PuzzlePupOfferEngine.addAndVerify({
          items,
          expectedMaxIncrease: selectedTotal(),
          source: kind === 'allergy' ? 'allergy_funnel' : 'snuffle_funnel',
          offerId: kind + '-' + selected + '-' + purchaseType,
          successEvent: 'pp_offer_verified'
        });
        await window.PuzzlePupStorefront?.refreshCartSurfaces?.();
        window.PuzzlePupStorefront?.openCartDrawer?.();
        addButton.textContent = 'Added to your cart';
        window.setTimeout(() => {
          addButton.disabled = false;
          addButton.textContent = original;
          render();
        }, 1200);
      } catch (error) {
        addButton.disabled = false;
        addButton.textContent = original;
        if (errorBox) {
          errorBox.textContent = error.message || 'The offer could not be verified. Please try again.';
          errorBox.hidden = false;
        }
      }
    });

    root.addEventListener('pp:smartmat-offer-price-changed', () => {
      if (kind !== 'snuffle') return;
      basePrice = Number(root.dataset.basePrice);
      matPrice = Number(root.dataset.matPrice || basePrice);
      render();
    });

    render();
  });
})();